module.exports = __webpack_public_path__ + "Flag-180.fbac05418dca57fe13428950e47b1ad5.svg";